export const buildGraphSchema = (schema: Record<string, any> | Array<Record<string, any>>) => {
  if (!Array.isArray(schema)) {
    return schema;
  }

  return {
    '@context': 'https://schema.org',
    '@graph': schema
      .filter((item) => item && typeof item === 'object')
      // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
      .map(({ '@context': _context, ...item }) => item),
  };
};
